var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion-objective"},[_c('span',{staticClass:"quarter-header text-muted"},[_vm._v("Quarter "+_vm._s(_vm.formattedLevel))]),_vm._v(" "),_c('h3',{staticClass:"objective-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }